
/**
 * @param {string} param 
 * @returns {Boolean}
 * / 替换成 、
 */
 export function segmentationCharacter(param) {
   if(param) {
    return param.replace(/\//g, '、')
   }
}